import { combineReducers } from 'redux';

import CEPSetup from './setup/reducer';

export default combineReducers({
  CEPSetup,
});



// WEBPACK FOOTER //
// ./src/pages/cepsetup/state/reducer.js